export * from './components';

import { createRouter } from 'stencil-router-v2';
export { Components, JSX } from './components';

export const Router = createRouter();